Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedProps = void 0;
Object.defineProperty(exports, "useEvent", {
    enumerable: true,
    get: function get() {
        return _utils.useEvent;
    }
});
Object.defineProperty(exports, "useHandler", {
    enumerable: true,
    get: function get() {
        return _utils.useHandler;
    }
});
exports.useWorkletCallback = useWorkletCallback;
var _react = require("react");
var _useAnimatedStyle = require("./useAnimatedStyle");
var _PlatformChecker = require("../PlatformChecker");
var _utils = require("./utils");
var useAnimatedProps;
if ((0, _PlatformChecker.shouldBeUseWeb)()) {
    exports.useAnimatedProps = useAnimatedProps = function useAnimatedProps(updater, deps, adapters) {
        return (0, _useAnimatedStyle.useAnimatedStyle)(updater, deps, adapters, true);
    };
} else {
    exports.useAnimatedProps = useAnimatedProps = _useAnimatedStyle.useAnimatedStyle;
}
function useWorkletCallback(fun, deps) {
    return (0, _react.useCallback)(fun, deps != null ? deps : []);
}
